import { render, staticRenderFns } from "./VentasListaItem.vue?vue&type=template&id=257e8e42&"
import script from "./VentasListaItem.vue?vue&type=script&lang=js&"
export * from "./VentasListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports